<p>home works!</p>
<button (click)="goto()">products</button>